import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { communityInboxApi } from "@circle-react/api/communityInboxApi";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";
import type { Chat } from "@circle-react/types/CommunityInbox/Chat";
import { useToast } from "@circle-react-uikit/ToastV2";

export const usePauseAiAction = () => {
  const { updateChat } = useCommunityInboxStore();
  const toastr = useToast();

  const { mutateAsync: pauseAi, isLoading: isPauseAiLoading } = useMutation<
    Chat,
    ApiError,
    number
  >(id => communityInboxApi.pauseAi({ id }), {
    onSuccess: chat => {
      updateChat(chat, "admin");
      toastr.success(t("messaging.actions.pause_ai_success"));
    },
    onError: err => {
      console.error("Error while creating chat", err);
    },
  });

  const { mutateAsync: resumeAi, isLoading: isResumeAiLoading } = useMutation<
    Chat,
    ApiError,
    number
  >(id => communityInboxApi.resumeAi({ id }), {
    onSuccess: chat => {
      updateChat(chat, "admin");
      toastr.success(t("messaging.actions.resume_ai_success"));
    },
    onError: err => {
      console.error("Error while creating chat", err);
    },
  });

  return {
    pauseAi,
    isPauseAiLoading,
    resumeAi,
    isResumeAiLoading,
  };
};
